<template>
  <div class="card">
    <div :id="'l' + vehicle.idVehicle" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active p-2">
          <img :src="'../images/vehicles/' + vehicle.znamka + '_' + vehicle.letnik + '_' + vehicle.st_sedezev + '_1.JPG'" class="d-block w-100 rounded" alt="..." height="170"/>
        </div>
        <div class="carousel-item p-2">
          <img :src="'../images/vehicles/' + vehicle.znamka + '_' + vehicle.letnik + '_' + vehicle.st_sedezev + '_2.JPG'" class="d-block w-100 rounded" alt="..." height="170"/>
        </div>
        <div class="carousel-item p-2">
          <img :src="'../images/vehicles/' + vehicle.znamka + '_' + vehicle.letnik + '_' + vehicle.st_sedezev + '_3.JPG'" class="d-block w-100 rounded" alt="..." height="170"/>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" :data-bs-target="'#l' + vehicle.idVehicle" data-bs-slide="prev" >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" :data-bs-target="'#l' + vehicle.idVehicle" data-bs-slide="next" >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <div class="card-body p-2">
      <h5 class="card-title">{{vehicle.znamka}} {{vehicle.model}}</h5>
      <p class="card-text" v-if="vehicle.st_sedezev != 100"> {{vehicle.st_sedezev}} Sedežev <br /> Letnik: {{vehicle.letnik}} <br /> {{vehicle.registrska}} </p>
      <p class="card-text" v-else>Letnik: {{vehicle.letnik}} <br /> {{vehicle.registrska}} </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardVehicle",
  props:{
      vehicle: Object
  }
};
</script>